import {useState} from 'react'
import {checkoutDeliveryPreferences} from '@data/fragments/checkout/__generated__/checkoutDeliveryPreferences'
import canDeliverNow from '@helpers/websites/canDeliverNow'
import canSchedule from '@helpers/websites/canSchedule'
import {getSchedulingDays, isValidTime} from '@helpers/websites/scheduleHelpers'
import useMessage from '@hooks/useMessage'

export const DELIVERY_VALUES_ENUM = Object.freeze({
  deliver_now: 0,
  schedule_order: 1
})

const deliverNowOption = Object.freeze({
  label: 'Entregar ahora',
  value: DELIVERY_VALUES_ENUM.deliver_now
})

const scheduleOrderOption = Object.freeze({
  label: 'Programar pedido',
  value: DELIVERY_VALUES_ENUM.schedule_order
})

const defaultPrefs = {
  store: null,
  time: null
}

export const deliveryTypeIsField = (
  deliveryType: any[] | {label: string; value: number}
): deliveryType is {label: string; value: number} => {
  return Array.isArray(deliveryType) === false
}

export default function useTimeField({
  preferences = defaultPrefs,
  save
}: {
  preferences?: checkoutDeliveryPreferences | typeof defaultPrefs
  save: any
}) {
  const {store} = preferences

  // form value -> hour:day.
  const [time, setTime] = useState(preferences.time || 'now')
  // alert toasts.
  const showMessage = useMessage()

  let deliveryOptions = []

  if (canDeliverNow(store)) {
    deliveryOptions = [deliverNowOption]
  }

  if (canSchedule(store)) {
    deliveryOptions.push(scheduleOrderOption)
  }

  const initialDeliveryType = () => {
    // if the user has both options, leave the selector empty.
    if (!preferences.time && canDeliverNow) {
      return null
    }

    if (preferences.time === 'now' && canDeliverNow) return deliverNowOption

    // the user has schedule order as his only option, so set it as the initial value.
    return deliveryOptions
  }

  // selected form option
  const [deliveryType, setDeliveryType] = useState(initialDeliveryType())

  const updateTimePreference = async time => {
    try {
      if (isValidTime(time, getSchedulingDays(preferences))) {
        await save(time)
        showMessage('Se ha actualizado la programación del pedido')
      } else {
        showMessage('Programación inválida')
      }
    } catch (error) {
      showMessage(error.message)
    }
  }

  return {
    time,
    setTime,
    deliveryOptions,
    deliveryType,
    setDeliveryType,
    updateTimePreference,
    DELIVERY_VALUES_ENUM
  }
}
